import {
   GET_ASSIGNEE,
   CHANGE_ASSIGNEE
  } from "./type";
  
  const initialState = {
    assigneeList: [],
    assignee: {}
  }
  
  const siteAssigneeReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_ASSIGNEE:
        return {
          ...state,
          assigneeList: payload,
        };
      case CHANGE_ASSIGNEE:
        return {
          ...state,
          assignee: payload,
        };
      default:
        return {
          ...state,
        };
    }
  };
  
  export default siteAssigneeReducer;